export default __webpack_public_path__ + "static/media/27.3aff8b73.jpg";